module.exports = __webpack_public_path__ + "img/strategy_ub.8423bea6.svg";